import { createFileRoute } from '@tanstack/react-router'

import CompanyInformation from '../-components/company-information'

export const Route = createFileRoute(
  '/app/data/companies/$uuid/(mainPage)/insured/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { uuid } = Route.useParams()

  return <CompanyInformation companyUuid={uuid} />
}
